// import React from "react";

// function About() {
//   return (
//     <section className="about-one clearfix" id="aboutus">
//       <div className="container">
//         <div className="row">
//           {/* Start About One Left */}
//           <div className="col-xl-6">
//             <div className="about-one__left">
//               <ul className="about-one__left-img-box list-unstyled clearfix">
//                 <li className="about-one__left-single">
//                   <div className="about-one__left-img1">
//                     <img src="assets/images/suhani/about1.webp" alt="About Image 1" />
//                   </div>
//                 </li>
//                 <li className="about-one__left-single">
//                   <div className="about-one__left-img2">
//                     <img src="assets/images/suhani/about2.webp" alt="About Image 2" />
//                   </div>
//                 </li>
//               </ul>
//             </div>
//           </div>
//           {/* End About One Left */}

//           {/* Start About One Right */}
//           <div className="col-xl-6">
//             <div className="about-one__right">
//               <div className="section-title">
//                 <span className="section-title__tagline">About Suhani Builders</span>
//                 <h2 className="section-title__title">
//                   Innovative Solutions for Your Real Estate Journey
//                 </h2>
//               </div>
//               <div className="about-one__right-inner">
//                 <p className="about-one__right-text">
//                   Suhani Builders specializes in creating exceptional real estate opportunities that
//                   redefine comfort and quality. Our commitment to excellence is reflected in every
//                   project we undertake, ensuring unparalleled craftsmanship and customer satisfaction.
//                 </p>
//                 <ul className="about-one__right-list list-unstyled">
//                   <li className="about-one__right-list-item">
//                     <div className="icon">
//                       <span className="icon-confirmation"></span>
//                     </div>
//                     <div className="text">
//                       <p>Call Us Today For Your Real Estate Needs To Get Started</p>
//                     </div>
//                   </li>

//                   <li className="about-one__right-list-item">
//                     <div className="icon">
//                       <span className="icon-confirmation"></span>
//                     </div>
//                     <div className="text">
//                       <p>Disruptive Real Estate Investment Guidance, Execution And Maintenance</p>
//                     </div>
//                   </li>

//                   <li className="about-one__right-list-item">
//                     <div className="icon">
//                       <span className="icon-confirmation"></span>
//                     </div>
//                     <div className="text">
//                       <p>
//                         Fully Integrated End To End, Transparent And Low-cost Investment Property
//                         Management
//                       </p>
//                     </div>
//                   </li>

//                   <li className="about-one__right-list-item">
//                     <div className="icon">
//                       <span className="icon-confirmation"></span>
//                     </div>
//                     <div className="text">
//                       <p>Turnkey Construction Projects</p>
//                     </div>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//           {/* End About One Right */}
//         </div>
//       </div>
//     </section>
//   );
// }

// export default About;

import React, { useState, useRef, useEffect } from "react";
import ownerImg from "../assets/css/owner.jpg";

function About() {
  const [showModal, setShowModal] = useState(false);
  const contentRef = useRef(null);
  const buttonRef = useRef(null);
  const [imageHeight, setImageHeight] = useState("auto");

  useEffect(() => {
    const calcHeight = () => {
      if (contentRef.current && buttonRef.current) {
        const rightTop = contentRef.current.getBoundingClientRect().top;
        const btnBottom = buttonRef.current.getBoundingClientRect().bottom;
        const h = btnBottom - rightTop;
        setImageHeight(Math.max(220, Math.min(h, 550)));
      } else if (contentRef.current) {
        setImageHeight(Math.max(220, Math.min(contentRef.current.offsetHeight, 320)));
      }
    };
    calcHeight();
    window.addEventListener("resize", calcHeight);
    return () => window.removeEventListener("resize", calcHeight);
  }, []);

  return (
    <section className="about-one clearfix" id="aboutus">
      <div className="container">
        <div className="row align-items-stretch">
          {/* Start About One Left */}
          <div className="col-xl-6">
            <div className="about-one__left h-100">
              <div
                className="about-one__left-img-box "
                style={{
                  height:
                    imageHeight !== ""
                      ? `${imageHeight}px`
                      : "240px",
                  minHeight: "240px",
                }}
              >
                <div
                  className="about-one__left-img1 h-100"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "12px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={ownerImg}
                    alt="Owners"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      display: "block",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* End About One Left */}

          {/* Start About One Right */}
          <div className="col-xl-6">
            <div className="about-one__right" ref={contentRef}>
              <div className="section-title">
                <span className="section-title__tagline">About Us</span>
                <h2 className="section-title__title">
                  Building Stability, Creating Opportunity
                </h2>
              </div>
              <div
                className="about-one__right-inner"
                style={{ maxHeight: "280px", overflow: "hidden", position: "relative" }}
              >
                <p className="about-one__right-text">
                  What started as a practical side hustle has grown into something far more meaningful.
                  Like many families, we began our journey in corporate America, balancing demanding careers
                  with big dreams for the future. When college costs loomed, we took our first step into real
                  estate, to build stability and opportunity for our family. What began as a necessity quickly turned
                  into a passion.
                </p>
                <p className="about-one__right-text">
                  Starting in Jersey City, we learned the business from the ground up; understanding
                  neighborhoods, building relationships, and treating every property as if it were our own. As our
                  experience grew, so did our footprint. Over time, we expanded into New Brunswick,
                  Willingboro, and Jamesburg, steadily growing a portfolio rooted in long-term thinking and
                  hands-on care.
                </p>
                <p className="about-one__right-text">
                  At the heart of the business is a true partnership.
                </p>

                <div className="about-one__team-section">
                  <div className="about-one__team-item">
                    <div className="about-one__team-icon">
                      <span className="icon-confirmation"></span>
                    </div>
                    <div className="about-one__team-content">
                      <p>
                        <strong>Manan Shah</strong> is a licensed real estate agent with over 15+ years of experience,
                        has been involved in 150+ transactions and has helped close over $50+ million in residential and
                        investment real estate. He focuses on identifying new opportunities, leveraging projects, and
                        guiding strategic growth—always with an eye toward sustainability and smart expansion.
                      </p>
                    </div>
                  </div>

                  <div className="about-one__team-item">
                    <div className="about-one__team-icon">
                      <span className="icon-confirmation"></span>
                    </div>
                    <div className="about-one__team-content">
                      <p>
                        <strong>Suruchi Shah</strong>, as a licensed builder and head of construction, brings the operation to life, overseeing property management
                        and day-to-day operations. From tenant relationships to maintenance and long-term upkeep,
                        she ensures that every property is well cared for and every resident feels respected. Her
                        attention to detail and people-first approach are what turn buildings into homes.
                      </p>
                    </div>
                  </div>

                  <div className="about-one__team-item">
                    <div className="about-one__team-icon">
                      <span className="icon-confirmation"></span>
                    </div>
                    <div className="about-one__team-content">
                      <p>
                        Together, they've built a business that reflects their values—<strong>integrity, consistency, and trust</strong>.
                        They are also parents to two daughters, which has deeply shaped how they approach their
                        work. Every decision is made with the future in mind—not just for their family, but for the
                        communities they invest in.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "80px",
                    background: "linear-gradient(to bottom, rgba(255,255,255,0), #ffffff)",
                  }}
                />
              </div>
              <div style={{ marginTop: "16px" }}>
                <button
                  ref={buttonRef}
                  onClick={() => setShowModal(true)}
                  style={{
                    background: "transparent",
                    border: "1px solid var(--thm-base, #ff0000)",
                    color: "var(--thm-base, #ff0000)",
                    padding: "10px 18px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Know more
                </button>
              </div>
              {showModal && (
                <div
                  style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.6)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                  }}
                  onClick={() => setShowModal(false)}
                >
                  <div
                    style={{
                      background: "#ffffff",
                      borderRadius: "8px",
                      width: "90%",
                      maxWidth: "900px",
                      maxHeight: "80vh",
                      overflowY: "auto",
                      padding: "24px",
                      position: "relative",
                    }}
                    className="no-scrollbar"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={() => setShowModal(false)}
                      aria-label="Close"
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "12px",
                        background: "transparent",
                        border: "none",
                        fontSize: "24px",
                        cursor: "pointer",
                        lineHeight: 1,
                      }}
                    >
                      ×
                    </button>
                    <h3 style={{ marginTop: 0, marginBottom: "16px" }}>
                      About Us
                    </h3>
                    <div>
                      <p className="about-one__right-text">
                        What started as a practical side hustle has grown into something far more meaningful.
                        Like many families, we began our journey in corporate America, balancing demanding careers
                        with big dreams for the future. When college costs loomed, we took our first step into real
                        estate, to build stability and opportunity for our family. What began as a necessity quickly turned
                        into a passion.
                      </p>
                      <p className="about-one__right-text">
                        Starting in Jersey City, we learned the business from the ground up; understanding
                        neighborhoods, building relationships, and treating every property as if it were our own. As our
                        experience grew, so did our footprint. Over time, we expanded into New Brunswick,
                        Willingboro, Jamesburg, South Amboy, South River, Sayreville, Mount Holly and more, steadily growing a portfolio rooted in long-term thinking and
                        hands-on care.
                      </p>
                      <p className="about-one__right-text">
                        At the heart of the business is a true partnership.
                      </p>
                      <div className="about-one__team-section">
                        <div className="about-one__team-item">
                          <div className="about-one__team-icon">
                            <span className="icon-confirmation"></span>
                          </div>
                          <div className="about-one__team-content">
                            <p>
                              <strong>Manan Shah</strong> is a licensed real estate agent with over 15+ years of experience,
                              has been involved in 150+ transactions and has helped close over $50+ million in residential and
                              investment real estate. He focuses on identifying new opportunities, leveraging projects, and
                              guiding strategic growth—always with an eye toward sustainability and smart expansion.
                            </p>
                          </div>
                        </div>
                        <div className="about-one__team-item">
                          <div className="about-one__team-icon">
                            <span className="icon-confirmation"></span>
                          </div>
                          <div className="about-one__team-content">
                            <p>
                              <strong>Suruchi Shah</strong>, as a licensed builder and head of construction, brings the operation to life, overseeing property management
                              and day-to-day operations. From tenant relationships to maintenance and long-term upkeep,
                              she ensures that every property is well cared for and every resident feels respected. Her
                              attention to detail and people-first approach are what turn buildings into homes.
                            </p>
                          </div>
                        </div>
                        <div className="about-one__team-item">
                          <div className="about-one__team-icon">
                            <span className="icon-confirmation"></span>
                          </div>
                          <div className="about-one__team-content">
                            <p>
                              Together, they've built a business that reflects their values—<strong>integrity, consistency, and trust</strong>.
                              They are also parents to two daughters, which has deeply shaped how they approach their
                              work. Every decision is made with the future in mind—not just for their family, but for the
                              communities they invest in.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* End About One Right */}
        </div>
      </div>
    </section>
  );
}

export default About;
